module.exports = {
  organizer: '主办方',
  home: '主页',
  meeting: '会议',
  agenda: '议程',
  Sponsorship_exhibitors: '赞助与展商',
  why_sponsor: '为何赞助?',
  why_sponsor_text: 'SOLDOUT是长期专注于亚太及中国区域零售发展与创新的高端商务社交品牌，通过系列峰会与展览，持续影响并赋能零售企业，洞察零售新风向。',
  enroll: '报名',
  conference_pass: '会议通票',
  free_tickets: '免费门票',
  join_in_now: '即刻参与',
  new_inspiration: 'SMART RETAIL',
  new_inspiration_text: '2026.1.22深圳华南场SMART RETAIL智慧零售峰会聚焦“数字化转型”与“供应链革新”﹐汇聚100+中外品牌﹑300+领袖，以“政策+技术+案例”议程﹐为出海本土化与在华全球化提供双向赋能﹐推动行业韧性增长与价值共生。',
  series_spearker: '系列演讲嘉宾',
  speakers1: '杨洪滨',
  speakers1_text1: '副总裁、低温事业部',
  speakers1_text1: '副总裁、低温事业部',
  speakers1_text2: '总经理',
  speakers1_text3: '君乐宝',
  speakers2: '郑永强',
  speakers2_text1: 'XWAY品牌合伙人',
  speakers2_text2: '复星集团',
  speakers3: '张涛',
  speakers3_text1: '信息技术中心总经理',
  speakers3_text1: '信息技术中心总经理',
  speakers3_text2: '红星美凯龙家居集团',
  speakers4: '刘岩岩',
  speakers4_text1: '低温事业部副总经理',
  speakers4_text2: '君乐宝',
  speakers5: '陈志华',
  speakers5_text1: '副总经理',
  speakers5_text2: '杭州娃哈哈电商有限公司',
  speakers6: '叶心薇',
  speakers6_text1: '大中华区市场营销及技术科技高级副总裁',
  speakers6_text2: '雅高集团',
  speakers7: 'Jack Wu',
  speakers7_text1: '市场与零售总经理',
  speakers7_text2: 'k11',
  speakers8: '邓结娥',
  speakers8_text1: '大中华区业务规划与运营总监',
  speakers8_text2: '北面',
  speakers9: 'Aretha Chen',
  speakers9_text1: '采购总监',
  speakers9_text2: '马丁博士',
  speakers10: '徐立',
  speakers10_text1: '大中华IT总监',
  speakers10_text2: '欧瑞莲',
  speakers11: '吕薇琴',
  speakers11_text1: '新零售总监',
  speakers11_text2: '中乔体育',
  speakers12: '黄静如',
  speakers12_text1: '巴拉巴拉新零售总监',
  speakers12_text2: '森马',
  speakers13: '粱啸',
  speakers13_text1: '电子商务中心总监',
  speakers13_text2: '周大福',
  speakers14: '陈绍洪',
  speakers14_text1: '市场总经理',
  speakers14_text2: '榄菊集团',
  speakers15: '吴晓露',
  speakers15_text1: '市场与消费者洞察总监',
  speakers15_text2: '宜家中国',
  speakers16: '郭思含',
  speakers16_text1: '副总经理',
  speakers16_text2: '乐乐茶',
  speakers17: '黄叔睿',
  speakers17_text1: '首席品牌官',
  speakers17_text2: '老金磨方',
  speakers18: '曾佳',
  speakers18_text1: '首席品牌官',
  speakers18_text2: '圣元国际',
  speakers19: '胡淳惠',
  speakers19_text1: '信息管理部总经理',
  speakers19_text2: '爱琴海集团',
  speakers20: '许惟抡',
  speakers20_text1: 'CEO',
  speakers20_text2: 'CFB集团',

  speakers01: '王舟童',
  speakers01_text1: '首席架构师',
  speakers01_text2: 'Google Cloud',
  speakers02: 'Anson Bailey  ',
  speakers02_text1: '亚太消费者与零售负责人',
  speakers02_text2: '毕马威',
  speakers03: 'Edison Guo',
  speakers03_text1: '亚太区供应链物流资深总监',
  speakers03_text2: '历峰集团',
  speakers04: 'Kellyn Zhou',
  speakers04_text1: '创始人',
  speakers04_text2: 'KKLUE',
  speakers05: 'Kenny Leung',
  speakers05_text1: '亚太区数字技术办公室总监',
  speakers05_text2: '历峰集团',
  speakers06: '章洁霏',
  speakers06_text1: '供应链高级总监',
  speakers06_text2: '全棉时代',
  speakers07: '陈嘉炜',
  speakers07_text1: '计划物流总监',
  speakers07_text2: '拉芳家化',
  speakers08: '陈灵梅',
  speakers08_text1: '董事长',
  speakers08_text2: '赢家服饰',
  speakers09: '陈炜',
  speakers09_text1: '物流总监',
  speakers09_text2: '金拱门﹙中国）',
  speakers010: '陈志裕',
  speakers010_text1: '会员事务及数码服务总监',
  speakers010_text2: '香港货品编码协会',
  speakers011: '方磊',
  speakers011_text1: 'CIO',
  speakers011_text2: '江南布衣',
  speakers012: '龚锦羽',
  speakers012_text1: '市场总监',
  speakers012_text2: "Tea'stone",
  speakers013: '雷宇',
  speakers013_text1: '海外市场总监',
  speakers013_text2: '东鹏特饮',
  speakers014: '潘建国',
  speakers014_text1: '副总经理',
  speakers014_text2: '广州酒家',
  speakers015: '施云',
  speakers015_text1: '首席供应链官',
  speakers015_text2: '金拱门﹙中国）',
  speakers016: '唐洪杰',
  speakers016_text1: '供应链物流总经理',
  speakers016_text2: '嘉荣集团',
  speakers017: '王奇',
  speakers017_text1: '电商副总裁',
  speakers017_text2: '莎莎国际',
  speakers018: '王伟',
  speakers018_text1: '大中华区资深解决方案专家',
  speakers018_text2: 'BlueYonder',
  speakers019: '韦文璐',
  speakers019_text1: 'DELMIA供应链解决方案高级业务顾问',
  speakers019_text2: '达索系统',
  speakers020: '吴杰',
  speakers020_text1: '供应链总监',
  speakers020_text2: '冰泉化妆品',
  speakers021: '杨高晓',
  speakers021_text1: '创始人&CEO',
  speakers021_text2: 'FUFUSOUL',
  speakers022: '印祝波',
  speakers022_text1: '供应链总经理',
  speakers022_text2: '爸爸糖吐司&谷百分食品',
  speakers023: '于二年',
  speakers023_text1: 'CIO',
  speakers023_text2: '双鸽食品',
  speakers024: '钟展华',
  speakers024_text1: 'CIO',
  speakers024_text2: '甜啦啦',
  speakers025: '邹翔',
  speakers025_text1: 'AI业务集团销售总监',
  speakers025_text2: '神州数码',

  nine_img1: '前沿观察',
  nine_img2: '意向收集',
  nine_img3: '定向邀请',
  nine_img4: '闭门交流',
  nine_img5: '案例展示',
  nine_img6: '商务引荐',
  nine_img7: '会后追踪',
  nine_img8: '持续精细',
  nine_img9: '技术秀',
  sponsor: '赞助商',
  footer1: '全新2024',
  footer2: '联系我们',
  footer3: '地址：上海市普陀区中江路388国盛中心1号楼1901-1902',
  footer4: '邮箱：mk@huiyuexpo.com',
  footer5: '关于我们',
  footer6: '关于主办方',
  footer7: '关于SoldOut',
  footer8: '系列活动',
  footer9: '参与',
  footer10: '免费参会',
  footer11: '参会代表',
  footer12: '演讲嘉宾',
  footer13: '赞助支持',
  footer14: '媒体合作',
  why_speech: '为何演讲',
  why_speech_text: 'SOLDOUT系列峰会真诚欢迎零售领域专家以主题演讲嘉宾、圆桌讨论嘉宾或大会主持人身份加入。如果您有意向加入该高端零售社交圈，请填写以下申请表，具体以SOLDOUT组委会审核结果为准，审核一般在一到两个工作日内。',
  apply_speech: '申请演讲',
  speech_item1: '闭门案例分析与展示',
  speech_item2: '吸引零售项目合作伙伴',
  speech_item3: '提高项目可信度、知名度',
  speech_item4: '拓展零售高层人脉',
  speech_item5: '加速战略部署与市场布局',
  speech_item6: '巩固您的行业地位',
  day1: '2023年7月20日 第一天',
  day1_1: '开幕致辞',
  day1_2: '主题演讲：零售差异化发展的核心驱动力',
  day1_3: '主题演讲：“颜值经济” 软性竞争力，探索元宇宙时代的消费新机会',
  day1_4: '主题演讲：渠道数字化创新引领品牌复兴，开创中国白酒新消费格局',
  day1_5: '上午茶歇、展台参观技术秀、互动交流',
  day1_6: '主题演讲：心怀用户，做信任经济用户运营',
  day1_7: '赞助商机',
  day1_8: '圆桌讨论：打通和优化全链路新零售，实现“品效销合一”的整体提升',
  day1_9: '午餐时间',
  day1_10: '主题演讲：DTC2.0时代，体育行业如何抢占先机？',
  day1_11: '赞助商机会',
  day1_12: '主题演讲：加速数智化布局，重构零售全链路',
  day1_13: '主题演讲：探索“数智融合” ，引领品类增长模式创新',
  day1_14: '下午茶歇、展台参观技术秀、互动交流',
  day1_15: '圆桌讨论：新消费时代，品牌如何利用零售与营销技术升级拓展',
  day1_16: '会议闭幕',
  day2: '2023年7月21日 第二天',
  day2_1: '开幕致辞',
  day2_2: '主题演讲：以消费者为中心，实现长期价值创造',
  day2_3: '主题演讲：品牌渠道双赋能，加速布局健康休食市场',
  day2_4: '主题演讲：消费新世界，自我革新渗透新生代群体',
  day2_5: '上午茶歇、展台参观技术秀、互动交流',
  day2_6: '主题演讲：即时零售，开启智慧电商“鲜”时刻',
  day2_7: '赞助商机会',
  day2_8: '圆桌讨论：实体零售数字化转型,智慧门店打通全场景',
  day2_9: '午餐时间',
  day2_10: '主题演讲：创新营销打造好利来糕点王国',
  day2_11: '赞助商机会',
  day2_12: '主题演讲：数字化技术赋能全产业链、品牌的可持续发展',
  day2_13: '主题演讲：存量竞争时代，品牌差异化营销',
  day2_14: '下午茶歇、展台参观技术秀、互动交流',
  day2_15: '圆桌讨论：新品牌如何打造核心竞争力，抢占用户心智',
  day2_16: '会议闭幕',
  sponsorship_consultation: '赞助咨询',
  soldout_equity1: 'SOLDOUT赞助权益包括：',
  soldout_equity2: '闭门高层会议',
  soldout_equity3: '演讲分享',
  soldout_equity4: '圆桌讨论',
  soldout_equity5: '全方位会议宣传与推广',
  soldout_equity6: '会前意向客户定向邀请',
  soldout_equity7: '闭门项目交流',
  soldout_equity8: '一对一商务引荐',
  receive: '您将获得',
  receive1: '推广新技术、新案例',
  receive2: '吸引新客户、新合作',
  receive3: '提高品牌知名度、影响力',
  receive4: '拓展潜在客户高层人脉',
  receive5: '加速市场拓展与客户转化',
  receive6: '巩固行业地位和市场份额',
  sponsorship_opportunities_include: '赞助机会包括',
  opportunity1: '高层闭门',
  opportunity2: '主题演讲',
  opportunity3: '圆桌讨论',
  opportunity4: '展台展示',
  opportunity5: '技术秀',
  opportunity6: '广告宣传',
  tab1_1: '免费参会',
  tab1_2: '0元/位',
  tab1_3: '免费报名',
  tab1_4: '限7月1日截至',
  tab1_5: '1天会议',
  tab1_6: '技术秀参观',
  tab1_7: '展区参观',
  tab1_8: '茶歇交流',
  tab1_9: '免费注册与签到通道',
  tab1_10: '电子会议会刊',
  tab1_11: '五星自助午宴',
  tab1_12: '同声传译',
  tab1_13: '根据大会实际情况安排',
  tab1_14: '会后全套可公布ppt',
  tab1_15: '商务引荐',
  tab1_16: 'SVIP闭门交流',
  tab1_17: 'SVIP专属交流群',
  tab1_18: '会后引荐',
  tab2_1: 'VIP代表参会',
  tab2_2: '3800元/位',
  tab2_3: '4800元/位',
  tab2_4: '即刻注册',
  tab2_5: '7月1日恢复原价',
  tab2_6: '1天会议',
  tab2_7: '展区参观',
  tab2_8: '茶歇交流',
  tab2_9: '专属注册与签到通道',
  tab2_10: '纸质会议会刊',
  tab2_11: '茶歇糕点',
  tab2_12: '专属会议胸卡',
  tab2_13: '专属席卡与坐席',
  tab2_14: '专属会议胸卡',
  tab2_15: '五星自助午宴',
  tab2_16: '同声传译',
  tab2_17: '会后全套可公布PPT',
  tab2_18: '根据大会实际情况安排',
  tab2_19: '一对一商务引荐',
  tab2_20: '高层闭门交流',
  tab2_21: 'SVIP专属交流群',
  tab2_22: '会后引荐',
  tab3_1: 'SVIP参与贵宾',
  tab3_2: '3800元/位',
  tab3_3: '6800元/位',
  tab3_4: '即刻注册',
  tab3_5: '7月1日恢复原价',
  tab3_6: '1天会议',
  tab3_7: '展区参观',
  tab3_8: '茶歇交流',
  tab3_9: '专属注册与签到通道',
  tab3_10: '纸质会议会刊',
  tab3_11: '茶歇糕点',
  tab3_12: '专属会议胸卡',
  tab3_13: '专属席卡与坐席',
  tab3_14: '专属会议胸卡',
  tab3_15: '五星自助午宴',
  tab3_16: '同声传译',
  tab3_17: '会后全套可公布PPT',
  tab3_18: '根据大会实际情况安排',
  tab3_19: '一对一商务引荐',
  tab3_20: '高层闭门交流',
  tab3_21: 'SVIP专属交流群',
  tab3_22: '会后引荐',
  term_of_service: '服务条款',
  term1: '取消',
  term1_text: '此次会议不接受会议通票退款。',
  term2: '替换',
  term2_text: '会议通票可转移至同一企业下其他同事，或您可在一年内转移至SoldOut其他系列活动参与。如需替换，请至少提前个工作日通知组委会以便我们实时同步注册系统方便您或相关替换同事快速与会签到。若未提前告知且出席，则无法享有替换权益。',
  term3: '注意事项',
  term3_text: '发言人与议程实时更新。若部分演讲集嘉宾临时取消，我们将积极寻找同等级别或同等影响力的替代者。如果会议因任何原因取消召开，组委会的责任仅限于退还会议通票注册费用。您承认已知晓，无任何追加条件并授权主办方可与会议当日现场拍摄、录制可能包含您的音频、视频、图片素材，且今后可用于SoldOut系列活动的宣传与推广。',
  term_of_register: '注册条款'
}